import { Outlet } from 'react-router';

import { useShortcuts } from '../hooks/useShortcuts.js';
import { CommandPalette } from './CommandPalette.js';
import { HelpModal } from './HelpModal.js';
import { Sidebar } from './Sidebar.js';
import { TopBar } from './TopBar.js';

export function AppShell(): JSX.Element {
  useShortcuts();
  return (
    <div className="ax-app flex h-screen w-screen overflow-hidden">
      <Sidebar />
      <div className="flex-1 flex flex-col min-w-0">
        <TopBar />
        <main className="flex-1 overflow-y-auto bg-ax-obsidian">
          <Outlet />
        </main>
      </div>
      <CommandPalette />
      <HelpModal />
    </div>
  );
}
